import handlebars from "handlebars";

handlebars.registerHelper("increment", function (value) {
    return parseInt(value) + 1;
});

handlebars.registerHelper("for", function (from, to, incr, block) {
    var accum = "";
    for (var i = from; i < to; i += incr) accum += block.fn(i);
    return accum;
});

handlebars.registerHelper("ifCond", function (v1, v2, options) {
    if (v1 === v2) {
        return options.fn(this);
    }
    return options.inverse(this);
});

const compile = (htmlTemplate, data) => {
    const template = handlebars.compile(htmlTemplate);
    return template(data);
};

export default compile;
